/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step03m from '../components/Step03mView'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(props, 'fullQuote', {}),
        totalExhibitsSumInsured: get(props, 'fullQuote.response.stockBusinessAssets.totalExhibitsSumInsured', 0),
        totalSpecifiedItem: get(props, 'fullQuote.response.stockBusinessAssets.totalSpecifiedItem', 0),
        exhibitsItems: get(props, 'fullQuote.response.stockBusinessAssets.specifiedItem', {}),
        stockBusinessAssets: get(props, 'fullQuote.response.stockBusinessAssets', {}),
        incomingExhibitionLimit: get(props, 'fullQuote.response.stockBusinessAssets.incomingExhibitionLimit', 0),
        outgoingExhibitionLimit: get(props, 'fullQuote.response.stockBusinessAssets.outgoingExhibitionLimit', 0),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03m)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step03m.tsx